import React from "react";

const STRINGS = {
  en: {
    "nav.inventory": "Inventory",
    "nav.appointment": "Appointment",
    "nav.about": "About Joel",
    "nav.contact": "Contact",
    "nav.callJoel": "Call Joel",

    "hero.eyebrow": "01 / Senior Sales Consultant",
    "hero.headline1": "Skip the lot.",
    "hero.headline2": "Text Joel",
    "hero.headline3": "first.",
    "hero.lede":
      "I'm Joel Perez — your direct line at AutoNation Toyota South Austin. Pick a Toyota, book an appointment, or just ask me anything. No pressure. No runaround.",
    "hero.bookCta": "Book an Appointment",
    "hero.callCta": "Call",
    "hero.financeCta": "Apply for Financing",

    "fin.title": "Before we send you to financing",
    "fin.subtitle": "Drop your info so Joel can follow up and answer any credit questions personally. Takes 5 seconds.",
    "fin.name": "Full name *",
    "fin.phone": "Phone *",
    "fin.email": "Email (optional)",
    "fin.notes": "Anything I should know? (optional)",
    "fin.notesPh": "Trade-in, budget, timing...",
    "fin.submit": "Continue to Application →",
    "fin.submitting": "One sec...",
    "fin.skip": "Skip and just take me there",
    "fin.fillAll": "Please add your name and phone so Joel can help.",
    "fin.success": "Got it! Opening the financing page now — Joel will reach out shortly.",
    "hero.statCustomers": "Customers helped",
    "hero.statRating": "Avg. rating",
    "hero.statYears": "In the industry",
    "hero.statYearsNum": "10+ yrs",
    "hero.availableNow": "Available now",
    "hero.sameDay": "Same-day test drives",
    "hero.sameDaySub": "Text or call to lock a time today.",
    "hero.topRated": "Senior Consultant",

    "marquee.1": "TOYOTA MASTER CERTIFIED",
    "marquee.2": "10+ YEARS IN THE INDUSTRY",
    "marquee.3": "BILINGUAL · SE HABLA ESPAÑOL",
    "marquee.4": "★★★★★ 5-STAR SERVICE",
    "marquee.5": "NO-PRESSURE SALES",
    "marquee.6": "SAME-DAY TEST DRIVES",
    "marquee.7": "TRADE-INS WELCOMED",

    "inv.eyebrow": "02 / Inventory",
    "inv.h1a": "The Toyota lineup",
    "inv.h1b": "currently on my lot.",
    "inv.lede":
      "Click any model to see live inventory at autonationtoyotasouthaustin.com. Then text me to lock one in.",
    "inv.cta": "Don't see what you want? I'll find it. Period.",
    "inv.browseAll": "Browse full inventory",
    "inv.cat.All": "All",
    "inv.cat.Truck": "Trucks",
    "inv.cat.SUV": "SUVs",
    "inv.cat.Sedan": "Sedans",
    "inv.cat.Van": "Vans",

    "appt.eyebrow": "03 / Book a Visit",
    "appt.h1a": "Pick a time.",
    "appt.h1b": "I'll handle the rest.",
    "appt.lede":
      "Tell me when works for you and what you're considering. I'll have the vehicle pulled up front, paperwork ready, and a cold drink waiting.",
    "appt.bullet1": "No high-pressure sales tactics",
    "appt.bullet2": "Trade-in valuation in 10 minutes",
    "appt.bullet3": "Financing pre-approval on the spot",
    "appt.financeCta": "Apply for Financing Online",
    "appt.direct": "Or just call me direct →",
    "appt.name": "Name *",
    "appt.phone": "Phone *",
    "appt.email": "Email *",
    "appt.date": "Preferred Date *",
    "appt.time": "Preferred Time *",
    "appt.datePlaceholder": "Pick a date",
    "appt.timePlaceholder": "Pick a time",
    "appt.vehicle": "Vehicle of Interest",
    "appt.vehiclePlaceholder": "Any model in mind?",
    "appt.vehicleNotSure": "Not sure yet",
    "appt.vehicleUsed": "Used / Pre-owned",
    "appt.message": "Anything specific?",
    "appt.messagePlaceholder":
      "Trade-in info, financing questions, color preferences...",
    "appt.submit": "Request Appointment",
    "appt.submitting": "Sending...",
    "appt.disclaimer":
      "By submitting, you agree Joel can contact you about your request. No spam. Ever.",
    "appt.fillAll": "Please fill all required fields.",
    "appt.success": "Appointment requested! Joel will text you to confirm.",
    "appt.successTitle": "Got it. Talk soon.",
    "appt.successBody":
      "I'll text you within the hour to confirm your appointment. If it's urgent, call me at",
    "appt.bookAnother": "Book another",
    "appt.error": "Couldn't submit. Please call Joel at",

    "about.eyebrow": "04 / About Joel",
    "about.h1a": "Not your typical",
    "about.h1b": "car salesman.",
    "about.body":
      "Born in Acuña, Coahuila, México. Raised in Northeast Texas. I've been in the auto industry since I was 18 — more than a decade now — and I take real pride in matching every customer with the right vehicle for their life and budget. Bilingual, born in two cultures, and 100% in your corner from the first hello to the day you drive home.",
    "about.years": "10+",
    "about.yearsLabel": "Years in the industry",
    "about.value1Title": "Honest from minute one",
    "about.value1Body":
      "No bait pricing. No surprise fees. The number on the screen is the number we close on.",
    "about.value2Title": "Always reachable",
    "about.value2Body":
      "Text me at 9pm with a question. I'll answer. That's the job.",
    "about.value3Title": "Bilingual · Bicultural",
    "about.value3Body":
      "English or Spanish, whichever feels like home. Hablo español con gusto — pregúntame lo que sea.",

    "contact.eyebrow": "05 / Get in Touch",
    "contact.h1a": "Questions?",
    "contact.h1b": "Just ask.",
    "contact.directLine": "Joel's direct line",
    "contact.dealership": "Dealership",
    "contact.hours": "Hours",
    "contact.formName": "Name *",
    "contact.formEmail": "Email *",
    "contact.formPhone": "Phone",
    "contact.formSubject": "Subject",
    "contact.formSubjectPh": "e.g. Trade-in question",
    "contact.formMessage": "Message *",
    "contact.send": "Send Message",
    "contact.sending": "Sending...",
    "contact.required": "Name, email and message are required.",
    "contact.success": "Message sent! Joel will get back to you shortly.",
    "contact.error": "Couldn't send. Call Joel at",

    "footer.tagline":
      "Your direct line to a no-pressure car buying experience in Austin, TX. Toyota Master Certified. Bilingual. Texas raised.",
    "footer.contact": "Contact",
    "footer.quickLinks": "Quick links",
    "footer.bookAppt": "Book Appointment",
    "footer.finance": "Apply for Financing",
    "footer.copyright":
      "© {year} Joel Perez — AutoNation Toyota South Austin. All rights reserved.",
    "footer.note":
      "Independent sales consultant page. Inventory subject to availability.",

    "chat.welcome":
      "Hey! I'm Joel's assistant. Ask me about Toyota models, financing, hours — or I can help you book a test drive. What's on your mind?",
    "chat.placeholder": "Ask anything...",
    "chat.online": "Online",
    "chat.title": "Joel's Assistant",
    "chat.quick1": "What's the difference between RAV4 and Highlander?",
    "chat.quick2": "Do you have any Tacomas in stock?",
    "chat.quick3": "What are your hours today?",
    "chat.error":
      "Hmm, I'm having trouble connecting. You can always call Joel at",

    "lang.toggle": "ES",
    "lang.tooltip": "Cambiar a Español",
  },
  es: {
    "nav.inventory": "Inventario",
    "nav.appointment": "Cita",
    "nav.about": "Sobre Joel",
    "nav.contact": "Contacto",
    "nav.callJoel": "Llamar a Joel",

    "hero.eyebrow": "01 / Asesor Senior de Ventas",
    "hero.headline1": "Sin pasar al lote.",
    "hero.headline2": "Habla con Joel",
    "hero.headline3": "primero.",
    "hero.lede":
      "Soy Joel Pérez — tu contacto directo en AutoNation Toyota South Austin. Elige tu Toyota, agenda una cita, o pregúntame lo que sea. Sin presión. Sin vueltas.",
    "hero.bookCta": "Agendar una Cita",
    "hero.callCta": "Llamar",
    "hero.financeCta": "Solicitar Financiamiento",

    "fin.title": "Antes de mandarte a financiamiento",
    "fin.subtitle": "Déjame tus datos para poder darle seguimiento personalmente y responder cualquier duda de crédito. Toma 5 segundos.",
    "fin.name": "Nombre completo *",
    "fin.phone": "Teléfono *",
    "fin.email": "Correo (opcional)",
    "fin.notes": "¿Algo que deba saber? (opcional)",
    "fin.notesPh": "Auto a entregar, presupuesto, fechas...",
    "fin.submit": "Continuar a la Solicitud →",
    "fin.submitting": "Un momento...",
    "fin.skip": "Saltar y solo llévame allá",
    "fin.fillAll": "Por favor déjame tu nombre y teléfono para ayudarte.",
    "fin.success": "¡Listo! Abriendo la página de financiamiento — Joel te contactará pronto.",
    "hero.statCustomers": "Clientes atendidos",
    "hero.statRating": "Calificación",
    "hero.statYears": "En la industria",
    "hero.statYearsNum": "10+ años",
    "hero.availableNow": "Disponible ahora",
    "hero.sameDay": "Pruebas de manejo el mismo día",
    "hero.sameDaySub": "Llámame o envíame mensaje para apartar una hora hoy.",
    "hero.topRated": "Asesor Senior",

    "marquee.1": "TOYOTA MASTER CERTIFIED",
    "marquee.2": "+10 AÑOS EN LA INDUSTRIA",
    "marquee.3": "BILINGÜE · SE HABLA ESPAÑOL",
    "marquee.4": "★★★★★ SERVICIO 5 ESTRELLAS",
    "marquee.5": "VENTA SIN PRESIÓN",
    "marquee.6": "PRUEBAS DE MANEJO HOY",
    "marquee.7": "ACEPTAMOS TU AUTO ACTUAL",

    "inv.eyebrow": "02 / Inventario",
    "inv.h1a": "La línea Toyota",
    "inv.h1b": "actualmente en mi lote.",
    "inv.lede":
      "Haz clic en cualquier modelo para ver el inventario en vivo en autonationtoyotasouthaustin.com. Luego escríbeme para apartar el tuyo.",
    "inv.cta": "¿No ves lo que buscas? Yo te lo consigo. Punto.",
    "inv.browseAll": "Ver inventario completo",
    "inv.cat.All": "Todos",
    "inv.cat.Truck": "Trocas",
    "inv.cat.SUV": "SUVs",
    "inv.cat.Sedan": "Sedanes",
    "inv.cat.Van": "Vans",

    "appt.eyebrow": "03 / Agenda una Visita",
    "appt.h1a": "Elige una hora.",
    "appt.h1b": "Yo me encargo del resto.",
    "appt.lede":
      "Dime cuándo te queda bien y qué estás considerando. Tendré el vehículo listo al frente, los papeles en orden y una bebida fría esperándote.",
    "appt.bullet1": "Sin tácticas de presión",
    "appt.bullet2": "Valoración de tu carro en 10 minutos",
    "appt.bullet3": "Pre-aprobación de financiamiento al instante",
    "appt.financeCta": "Solicitar Financiamiento en Línea",
    "appt.direct": "O llámame directamente →",
    "appt.name": "Nombre *",
    "appt.phone": "Teléfono *",
    "appt.email": "Correo *",
    "appt.date": "Fecha preferida *",
    "appt.time": "Hora preferida *",
    "appt.datePlaceholder": "Elige una fecha",
    "appt.timePlaceholder": "Elige una hora",
    "appt.vehicle": "Vehículo de Interés",
    "appt.vehiclePlaceholder": "¿Algún modelo en mente?",
    "appt.vehicleNotSure": "Aún no estoy seguro",
    "appt.vehicleUsed": "Usado / Seminuevo",
    "appt.message": "¿Algo específico?",
    "appt.messagePlaceholder":
      "Datos del auto a entregar, dudas de financiamiento, color preferido...",
    "appt.submit": "Solicitar Cita",
    "appt.submitting": "Enviando...",
    "appt.disclaimer":
      "Al enviar, aceptas que Joel te contacte sobre tu solicitud. Sin spam. Nunca.",
    "appt.fillAll": "Por favor llena todos los campos requeridos.",
    "appt.success": "¡Cita solicitada! Joel te enviará un mensaje para confirmar.",
    "appt.successTitle": "Listo. Nos hablamos pronto.",
    "appt.successBody":
      "Te escribiré dentro de la hora para confirmar tu cita. Si es urgente, llámame al",
    "appt.bookAnother": "Agendar otra",
    "appt.error": "No se pudo enviar. Por favor llama a Joel al",

    "about.eyebrow": "04 / Sobre Joel",
    "about.h1a": "No soy el típico",
    "about.h1b": "vendedor de carros.",
    "about.body":
      "Nací en Acuña, Coahuila, México. Crecí en el noreste de Texas. Llevo en la industria automotriz desde los 18 años — más de una década — y me enorgullezco de encontrar el vehículo correcto para la vida y el bolsillo de cada cliente. Bilingüe, con raíces en dos culturas, y 100% de tu lado desde el primer saludo hasta el día que te lleves tu carro a casa.",
    "about.years": "10+",
    "about.yearsLabel": "Años en la industria",
    "about.value1Title": "Honesto desde el minuto uno",
    "about.value1Body":
      "Sin precios anzuelo. Sin cargos sorpresa. El número en pantalla es con el que cerramos.",
    "about.value2Title": "Siempre disponible",
    "about.value2Body":
      "Escríbeme a las 9 PM con una pregunta. Te contesto. Ese es el trabajo.",
    "about.value3Title": "Bilingüe · Bicultural",
    "about.value3Body":
      "Inglés o español, lo que se sienta como casa. Hablo español con gusto — pregúntame lo que sea.",

    "contact.eyebrow": "05 / Contáctame",
    "contact.h1a": "¿Preguntas?",
    "contact.h1b": "Solo pregunta.",
    "contact.directLine": "Línea directa de Joel",
    "contact.dealership": "Concesionario",
    "contact.hours": "Horario",
    "contact.formName": "Nombre *",
    "contact.formEmail": "Correo *",
    "contact.formPhone": "Teléfono",
    "contact.formSubject": "Asunto",
    "contact.formSubjectPh": "ej. Pregunta sobre mi carro actual",
    "contact.formMessage": "Mensaje *",
    "contact.send": "Enviar Mensaje",
    "contact.sending": "Enviando...",
    "contact.required": "Nombre, correo y mensaje son obligatorios.",
    "contact.success": "¡Mensaje enviado! Joel te responderá en breve.",
    "contact.error": "No se pudo enviar. Llama a Joel al",

    "footer.tagline":
      "Tu contacto directo para una experiencia de compra sin presión en Austin, TX. Toyota Master Certified. Bilingüe. Criado en Texas.",
    "footer.contact": "Contacto",
    "footer.quickLinks": "Enlaces rápidos",
    "footer.bookAppt": "Agendar Cita",
    "footer.finance": "Solicitar Financiamiento",
    "footer.copyright":
      "© {year} Joel Perez — AutoNation Toyota South Austin. Todos los derechos reservados.",
    "footer.note":
      "Página independiente del asesor de ventas. Inventario sujeto a disponibilidad.",

    "chat.welcome":
      "¡Hola! Soy el asistente de Joel. Pregúntame sobre modelos Toyota, financiamiento, horarios — o te ayudo a agendar una prueba de manejo. ¿En qué te ayudo?",
    "chat.placeholder": "Pregunta lo que sea...",
    "chat.online": "En línea",
    "chat.title": "Asistente de Joel",
    "chat.quick1": "¿Cuál es la diferencia entre RAV4 y Highlander?",
    "chat.quick2": "¿Tienes Tacomas disponibles?",
    "chat.quick3": "¿Cuál es tu horario hoy?",
    "chat.error":
      "Tengo problemas para conectarme. Siempre puedes llamar a Joel al",

    "lang.toggle": "EN",
    "lang.tooltip": "Switch to English",
  },
};

const LangContext = React.createContext({
  lang: "en",
  setLang: () => {},
  t: (k) => k,
});

export function LangProvider({ children }) {
  const [lang, setLangState] = React.useState(() => {
    try {
      const saved = localStorage.getItem("jp_lang");
      if (saved === "en" || saved === "es") return saved;
      // auto-detect
      const nav = (navigator.language || "en").toLowerCase();
      return nav.startsWith("es") ? "es" : "en";
    } catch {
      return "en";
    }
  });

  const setLang = React.useCallback((l) => {
    setLangState(l);
    try {
      localStorage.setItem("jp_lang", l);
    } catch {
      /* ignore */
    }
  }, []);

  React.useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = React.useCallback(
    (key) => {
      return STRINGS[lang]?.[key] ?? STRINGS.en[key] ?? key;
    },
    [lang]
  );

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useT = () => React.useContext(LangContext);
